/**
 * Dates, said the way a person reads a list.
 *
 * A row says "3h ago" because that is what an inbox is scanned for; the exact
 * moment is still there, in the `title` and in the detail pane.
 */
const DAY = 24 * 60 * 60 * 1000;

export function relativeTime(iso: string, now = Date.now()): string {
  const then = new Date(iso).getTime();
  const elapsed = now - then;
  if (elapsed < 60_000) return 'Just now';
  if (elapsed < 60 * 60_000) return `${Math.floor(elapsed / 60_000)}m ago`;
  if (elapsed < DAY) return `${Math.floor(elapsed / (60 * 60_000))}h ago`;
  if (elapsed < 7 * DAY) return `${Math.floor(elapsed / DAY)}d ago`;
  return shortDate(iso);
}

export function shortDate(iso: string): string {
  const date = new Date(iso);
  return date.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    ...(date.getFullYear() === new Date().getFullYear() ? {} : { year: 'numeric' }),
  });
}

export function dateTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

/** Two letters for an avatar: first and last word of a name. */
export function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  const first = words[0]!.charAt(0);
  const last = words.length > 1 ? words[words.length - 1]!.charAt(0) : '';
  return (first + last).toUpperCase();
}
